import React, { useEffect, useState, useRef } from 'react';
import { Link,Redirect } from "react-router-dom";
import { apiJson } from '../../../Api';
import CartSidebar from '../cart/CartSidebar';
import { useTranslation } from "react-i18next";
import { useOutsideAlerter } from '../../../utils/CustomHooks';
import { toast } from "react-toastify";
import { connect } from "react-redux";

const PriceComparison = (props) => {
  const { t } = useTranslation();
  let message = "";
  const sideCartRef = useRef(null);
  const [variants, setVariants] = useState([]);
  const [showCart, setShowCart] = useState(false);
  useOutsideAlerter(sideCartRef, setShowCart);
  const [cartRedirect, setCartRedirect] = useState(false);

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    apiJson
      .singleItem.getMultiVendorVariants(props.store_id, props.model_no)
      .then(response => {
        setVariants(response.data.products);
      })
      .catch()
  }, []);

  const addToCartApiMethod = (variant) => {
    // setAdding(true);
    apiJson.cart
      .addToCart(
        // props.data.product_type == "wholesale" ?
        //   {
        //     line_item: {
        //       quantity: parseInt(quantity.label ? quantity.label : quantity),
        //       orderable_type: "Variant",
        //       orderable_id: props.data.variantId,
        //       product_type: "wholesale"
        //     }
        //   }
        //   :
        // props.data.type === "Product"
        //   ? 
        {
          line_item: {
            quantity: 1,
            orderable_type: "Variant",
            orderable_id: variant.id,
            is_assembly_added: false,
            // ...(addAssembly && { assembly_id: props.item.assembly.id })
          },
        }
        // : {
        //   line_item: {
        //     orderable_type: "Service",
        //     orderable_id: props.data.order_id,
        //     start_at: new Date(startDate).toString(),
        //     service_type: props.data?.service_type,
        //     ...(props.data?.service_type !== "one_time" && { end_at: new Date(endDate).toString() })
        //   },
        // },
        , props.countryId
      )
      .then((response) => {
        // setAdding(false);
        if (response.success) {
          if (
            localStorage.getItem("access_token") ||
            localStorage.getItem("user_key") === response.data.user_key
          ) {
            if (props.width == "sm") {
              setCartRedirect(true);
            }
            else {
              setShowCart(true);
            }
          } else {
            localStorage.setItem("user_key", response.data.user_key);
            if (props.width == "sm") {
              setCartRedirect(true);
            }
            else {
              setShowCart(true);
            }
          }
        } else if (!response.status) {
          message = t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });
  }

  return (
    variants?.length ?
      <div className="price-comparison-container" style={{
        fontFamily: 'Arial, sans-serif',
        maxWidth: '600px',
        margin: '0 auto',
        padding: '0'
      }}>
        {/* First Box - Top Section (Updated with decimal alignment) */}
        {/* <div style={{ 
        border: '2px solid #ddd',
        borderRadius: '10px',
        padding: '15px',
        marginBottom: '55px',
        marginTop: '55px',

      }}>
        <div style={{ 
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '600', marginBottom: '5px', color: '#555' }}>
              New (5) from
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <span style={{ 
                fontSize: '14px', 
                marginRight: '4px',
                color: '#555',
                lineHeight: '21px',
                fontWeight: '600',
                alignSelf: 'flex-start'
              }}>AED</span>
              <span style={{ 
                fontSize: '22px',
                color: '#555',
                lineHeight: '30px',
                fontWeight: '600',
                marginRight: '2px'
              }}>137</span>
              <span style={{ 
                fontSize: '14px',
                color: '#555', 
                lineHeight: '21px',
                fontWeight: '600',
                marginLeft: '1px',
                alignSelf: 'flex-start' // Changed to flex-start to align with AED
              }}>45</span>
              <span style={{ 
                color: '#555', 
                fontSize: '18px', 
                fontFamily: "Futura Heavy",
                fontWeight: '600', 
                lineHeight: '30px',
                marginLeft: '12px'
              }}>
                FREE Delivery
              </span>
            </div>
          </div>
          <FiChevronRight style={{ 
            color: '#000', 
            fontSize: '25px', // Slightly larger
            marginLeft: '15px',
            strokeWidth: '2.5px' // Thicker stroke for better visibility
          }} />
        </div>
      </div> */}

        {/* Second Large Box - Updated as requested */}
        <div style={{
          border: '2px solid #ddd',
          borderRadius: '10px',
          padding: '0px'
        }}>
          {/* Heading */}
          <div style={{
            position: 'relative',
            textAlign: 'center',
            padding: '15px 0'
          }}>
            <div style={{
              fontSize: props.width == "sm" ? '16px' : '20px',
              fontWeight: '600',
              color: '#555',
              position: 'relative',
              display: 'inline-block',
              padding: '0 px',
              fontFamily: "Futura Heavy",
              backgroundColor: 'white'
            }}>
              Other Sellers on Alisouq
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '100%',
                right: '-1000px',
                height: '0px',
                backgroundColor: '#eee',
                zIndex: -1
              }}></div>
              {/* <div style={{ 
              position: 'absolute',
              top: '10%',
              right: '100%',
              left: '-1000px',
              height: '0px',
              backgroundColor: '#eee',
              zIndex: -1
            }}></div> */}
            </div>
          </div>

          {/* Seller 1 */}
          {
            variants?.map((variant) => {
              return (
                <div style={{
                  padding: '15px',
                  borderTop: '2px solid #eee',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}>
                  <Link
                    to={{
                      pathname:
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        `/${variant.category_title_en?.toLowerCase().replace(/ /g, "-")}/${variant.product_slug
                        }`,
                      state: {
                        id: variant.product_id,
                        type: "products",
                        sku: variant.sku,
                      },
                      search: "?sku=" + variant.sku,
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '5px' }}>
                      <span style={{
                        fontSize: props.width == "sm" ? '15px' : '18px',
                        marginRight: '4px',
                        color: '#555',
                        fontWeight: '600',
                        lineHeight: '18px',
                      }}>AED</span>
                      <span style={{
                        fontSize: props.width == "sm" ? '15px' : '18px',
                        color: '#555',
                        fontWeight: '600',
                        lineHeight: '18px',

                      }}>{variant.discounted_price}</span>
                    </div>
                    <div style={{ color: '#555', fontSize: props.width == "sm" ? '11px' : '13px', marginBottom: '5px', fontWeight: '600', fontFamily: "Futura Heavy", }}>
                      & FREE Shipping
                    </div>
                    <div style={{ fontSize: props.width == "sm" ? '11px' : '12px', color: '#555' }}>
                      Sold by: <span style={{ color: '#555', fontWeight: '600' }}>{`${variant.store_name_en}`}</span>
                    </div>
                  </Link>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <button style={{
                      backgroundColor: '#003366',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: '600',
                      fontSize: props.width == "sm" ? '11px' : '13px',
                      height: '32px',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                      whiteSpace: 'nowrap',
                      color: 'white',
                    }}
                      onClick={() => addToCartApiMethod(variant)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              )
            })
          }

          {/* <div style={{
          padding: '15px',
          borderTop: '2px solid #eee',
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '5px' }}>
              <span style={{
                fontSize: '18px',
                marginRight: '4px',
                color: '#555',
                lineHeight: '18px',
                fontWeight: '600',
              }}>AED</span>
              <span style={{
                fontSize: '18px',
                color: '#555',
                lineHeight: '18px',
                fontWeight: '600',
              }}>153.95</span>
            </div>
            <div style={{ color: '#555', fontSize: '13px', marginBottom: '5px', fontWeight: '600', fontFamily: "Futura Heavy", }}>
              & FREE Shipping. <a href='#' style={{ color: '#0066c0', fontSize: '13px', marginBottom: '5px', fontWeight: '100', }}>Details</a>
            </div>
            <div style={{ fontSize: '12px', color: '#555' }}>
              Sold by: <span style={{ color: '#555', fontWeight: '600', }}>Amazon.ae</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <button style={{
              backgroundColor: '#003366',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '13px',
              height: '32px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              whiteSpace: 'nowrap',
              color: 'white',
            }}>
              Add to Cart
            </button>
          </div>
        </div>

        <div style={{
          padding: '15px',
          borderTop: '1px solid #eee',
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '5px' }}>
              <span style={{
                fontSize: '18px',
                marginRight: '4px',
                color: '#555',
                lineHeight: '18px',
                fontWeight: '600',
              }}>AED</span>
              <span style={{
                fontSize: '18px',
                color: '#555',
                lineHeight: '18px',
                fontWeight: '600',
              }}>136.81</span>
            </div>
            <div style={{ fontSize: '13px', marginBottom: '5px', color: '#555' }}>
              + <span style={{ color: '#555' }}>AED 78.83</span> shipping
            </div>
            <div style={{ fontSize: '12px', color: '#555', fontWeight: '400', }}>
              Sold by: <span style={{ color: '#555', fontWeight: '600', }}>US Picks</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <button style={{
              backgroundColor: '#003366',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '13px',
              height: '32px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
              whiteSpace: 'nowrap',
              color: 'white',
            }}>
              Add to Cart
            </button>
          </div>
        </div> */}
        </div>

        {showCart && <CartSidebar refs={sideCartRef} bool={showCart} />}
        {cartRedirect &&
        <Redirect
          push
          to={
            "/" + props.countryUrl + "-" + props.language + "/cart"
          } />}
      </div>
      :
      <></>
  );
};

const mapStateToProps = (state) => {
  return {
    country: state.language.country,
    language: state.language.language,
    countryUrl: state.language.countryUrl,
    countryId: state.language.countryId,
    width: state.layout.screenWidth,
  };
};

const mapDispatchToProps = { };
export default connect(mapStateToProps, mapDispatchToProps)(PriceComparison);
